//
//
//
//
//
//
//
//
//
//
//
//

import { getToday, getAppointNMonth, matomofn } from '~/assets/js/utils.js'
import breadCrumbs from '~/components/common/breadCrumbs.vue'
import fundsFlow from '~/components/cashflow/fundsFlow.vue'
import overnightFee from '~/components/cashflow/overnightFee.vue'
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'funds-flow': fundsFlow,
    'overnight-fee': overnightFee
  },
  async asyncData ({ $api, store }) {
    try {
      const { locale = 'en' } = store.state
      const startTime = getAppointNMonth('', 1)
      const endTime = getToday()
      const [cashInOut, rankForCash, tradeTrend, swap, brokerRankForSwap] = await Promise.all([
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/cashInOut' }, { startTime, endTime }).catch(() => { console.log('/mt4Extend/cashInOut') }), // 流入流出-历史流转
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/brokerRankForCash' }, { period: 2 }).catch(() => { console.log('/mt4Extend/brokerRankForCash') }), // 交易商资金净流入排行
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/tradeTrend' }, { languageCode: locale, type: 'speed', symbol: 'eurusd' }).catch(() => { console.log('/mt4Extend/tradeTrend') }), // 交易环境走势-获取数据更新时间
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/swap' }, { startTime, endTime }).catch(() => { console.log('/mt4Extend/swap') }), // 隔夜费
        $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/brokerRankForSwap' }, { period: 2 }).catch(() => { console.log('/mt4Extend/brokerRankForSwap') }) // 隔夜费-收入排行
      ])
      return {
        cashInOut: cashInOut || {},
        rankForCash: rankForCash || {},
        tradeTrend: tradeTrend || {},
        swap: swap || {},
        brokerRankForSwap: brokerRankForSwap || {}
      }
    } catch (error) { console.log(error) }
  },
  data () {
    return {
      pageEnterTime: null // 页面进入时间
    }
  },
  head () {
    return {
      title: this.$t('29345'),
      meta: [
        { name: 'Description', content: this.$t('29346') }
      ]
    }
  },
  created () {},
  mounted () {
    // 记录页面进入时间
    this.pageEnterTime = Date.now()
    // 监听页面关闭事件
    window.addEventListener('beforeunload', this.trackPageTime)
  },
  beforeDestroy () {
    // 移除事件监听器
    window.removeEventListener('beforeunload', this.trackPageTime)
    // 执行页面时间统计
    this.trackPageTime()
  },
  methods: {
    // 页面时间统计
    trackPageTime () {
      if (this.pageEnterTime) {
        const exitTime = Date.now()
        matomofn('Cloud_Cash_Flow_Time', {
          af_Enter: this.pageEnterTime,
          af_Exit: exitTime
        }, this.$store.state, this.$cookies)
      }
    }
  }
}
